import React from 'react';
// import styles from './Achievements.module.scss';

export const Achievements: React.FC = () => {
  return (
    <section id="achievements" className="chapter">
      <h2>開発実績</h2>
    </section>
  );
};
